const Types = {
  STARTUP: 'app/STARTUP',

  SET_USER: 'auth/SET_USER',
  LOGOUT: 'auth/LOGOUT',
};

export default Types;



// WEBPACK FOOTER //
// ./src/actions/Types.js